import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const Edit = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { slug } = useParams();
  const { loading, error, section } = useSelector((state) => state.section);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    dispatch(getSection({ page: "seo", slug: slug }));
  }, [dispatch, slug]);

  useEffect(() => {
    reset({
      ...section,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    dispatch(
      editSection({
        slug: slug,
        page: "seo",
        redirect: "seo",
        data: { section: data },
        navigate,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"editSeo"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Col md={12}>
              {/* name  */}
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="metaTitle"
                    name="metaTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="metaTitle"
                    name="metaTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>

                <Col lg={6} xs={12}>
                  <Textarea
                    langId="metaDescription"
                    name="metaDescription.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="metaDescription"
                    name="metaDescription.en"
                    register={register}
                    errors={errors}
                  />
                </Col>

                <Col lg={6} xs={12}>
                  <Textarea
                    langId="metaKeywords"
                    name="metaKeywords.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="metaKeywords"
                    name="metaKeywords.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>

              <SaveChangesButton />
            </Col>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Edit;
